import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar as CalIcon } from "lucide-react";
import AppLayout from "../components/AppLayout";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";

const TYPE_PATH = { match: "matches", lesson: "lessons", tournament: "tournaments" };

export default function CalendarPage() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/calendar/me").then((r) => setItems(r.data)); }, []);
  return (
    <AppLayout>
      <h1 className="font-heading text-3xl sm:text-4xl font-black flex items-center gap-3"><CalIcon size={28} className="text-[#00E676]" /> {t("calendar")}</h1>
      <p className="text-zinc-400 mt-2">{t("upcoming")}</p>
      <div className="mt-8 space-y-3" data-testid="calendar-list">
        {items.map((it) => (
          <Link key={`${it.type}-${it.id}`} to={`/${TYPE_PATH[it.type]}/${it.id}`} className="pp-card p-5 flex items-center justify-between hover:border-[#00E676]/40">
            <div>
              <div className="text-xs text-[#00E676] uppercase tracking-wider">{it.type}</div>
              <div className="font-heading font-bold mt-1">{it.title}</div>
            </div>
            <div className="text-sm text-zinc-400">{new Date(it.start_time).toLocaleString()}</div>
          </Link>
        ))}
        {items.length === 0 && <div className="pp-card p-10 text-center text-zinc-500" data-testid="calendar-empty">{t("no_results")}</div>}
      </div>
    </AppLayout>
  );
}
